import React, { useState } from 'react'
import classNames from 'classnames'
import { Link } from 'gatsby'
import Container from './container'
import Nav from './nav'
import logo from '../images/logo-blue.svg'
import bars from '../images/bars.svg'
import times from '../images/times.svg'
import styles from './header.module.scss'

const items = [
  {
    to: '/',
    label: 'Home',
  },
  {
    to: '/why-rheia',
    label: 'Why Rheia',
  },
  {
    to: '/products',
    label: 'Products',
  },
  {
    to: '/about',
    label: 'About',
  },
  {
    to: '/faq/',
    label: 'FAQ',
    partial: true,
  },
  {
    to: '/contact',
    label: 'Contact',
  },
  {
    to: '/resources',
    label: 'Resources',
    partial: true,
  }
]

const Header = () => {
  const [ open, setOpen ] = useState( false )

  return (
    <header className={ classNames( styles.header, open && styles.open ) }>
      <Container className={ styles.container }>
        <Link to="/" className={ styles.logo }>
          <img src={ logo } alt="Rheia" />
        </Link>

        <button type="button" className={ styles.toggle } onClick={ () => setOpen( ! open ) }>
          <img src={ bars } alt="Open Menu" className={ styles.bars } />
          <img src={ times } alt="Close Menu" className={ styles.times } />
        </button>
        
        <nav className={ styles.nav }>
          <Nav items={ items } alignment="stretch" activeClassName={ styles.active } />
        </nav>
      </Container>
    </header>
  )
}

export default Header
